<template>
  <div class="config-group small-12 column d-flex flex-column align-items-center">
    <div class="config-item w-100 my-auto position-relative">
        <div class="config-item__info d-inline-flex">
            <label for="auflage_input">{{'lblAuflage'|translate}}</label>
            <Tooltip v-if="tooltip" :infoText="tooltip"/>
        </div>
        <div class="d-flex">
            <input type="number" class="text-center input--auflage" required id="auflage_input" :readonly="!editable"
                   :value="individualAuflage" :step="option.customValues.schrittgroesseAuflageIndividuell" @change="checkAndUpdateValue( $event )" />
            <a @click.prevent="showModal" class="btn btn--dark ml-1 w-100@until-medium">{{'lblPreistabelle'|translate}}</a>
        </div>

        <div v-if="message" class="text-small mt-prj text-error d-flex line-height-12 option-auflage-error"> 
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
            {{'txtNote'|translate}} {{ message }}
        </div>
        
        <FlyerlineModal name="auflagen">
            <div>
                <div class="row m-0 show-for-medium bg-secondary text-white">
                    <div class="column font-weight-bold py-prj2">{{'lblAuflage'|translate}}</div>
                    <div class="column font-weight-bold py-prj2 border-left border-white">{{'lblPreis'|translate}} <small class="d-block font-weight-light">{{'txtExclVATNoInf'|translate}}</small></div>
                    <div class="column font-weight-bold py-prj2 border-left border-white">{{'lblPreis'|translate}} <small class="d-block font-weight-light">{{'txtInclVATNoInf'|translate}}</small></div>
                    <div class="column py-prj2 border-left border-white d-flex justify-content-end flex-child-fix">
                        <div class="btn btn--link btn--prj-min-x"><div class="sr-only" aria-hidden="true">{{'btnChoose'|translate}}</div></div>
                    </div>
                </div>
                <div v-if="!canShowPrices" class="p-prj2 pl-5 bg-error text-white line-height-12 position-relative">
                    <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon flex-child-fix position-absolute error-negative-icon" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#fff"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#e94d47"/></svg>
                    {{ this.configuratorService.observableData.data.overallStatus.message }}
                </div>
                <div class="v-spacing-child-3@until-medium my-children-1px@medium">
                    <template v-for="auflage in auflagenWithPrice">
                        <div class="row flex-column@until-medium ml-0 mr-0 bg-shade-light v-spacing-child-3@until-medium auflagen" v-bind:key="auflage.id" v-if="auflage.status !== 'EXCLUDED'">
                            <div class="column py-prj2 py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium">
                                <div class="font-weight-bold hide-for-medium">{{'lblAuflage'|translate}}</div>
                                <div class="font-weight-bold-medium">{{auflage.name}}</div>
    <!--
    This would be a way to indicate which auflage won't reset any other part
    {{isExcludedByValues(auflage, values) ? "Setzt andere Einstellungen zurück" : "Wählbar"}}
    -->
                            </div>
                            <div class="column flex-child-auto@until-medium py-prj py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium border-left border-white">
                                <div v-if="canShowPrices" class="d-flex justify-content-between@until-medium w-100">
                                    <div class="font-weight-bold hide-for-medium">{{'lblPreis'|translate}} <small class="d-block font-weight-light">{{'txtExclVATNoInf'|translate}}</small></div>
                                    <div>{{auflage.priceExcl}} <s v-if="auflage.normalPriceExcl" class="pl-2">{{auflage.normalPriceExcl}}</s></div>
                                </div>
                            </div>
                            <div class="column flex-child-auto@until-medium py-prj py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium border-left border-white">
                                <div v-if="canShowPrices" class="d-flex justify-content-between@until-medium w-100">
                                    <div class="font-weight-bold hide-for-medium">{{'lblPreis'|translate}} <small class="d-block font-weight-light">{{'txtInclVATNoInf'|translate}}</small></div>
                                    <div>{{auflage.priceIncl}} <s v-if="auflage.normalPriceIncl" class="pl-2">{{auflage.normalPriceIncl}}</s></div>
                                </div>
                            </div>
                            <div class="column py-prj2 d-flex align-items-center border-left border-white d-flex justify-content-end flex-child-fix"><a href="javascript:void(0)" class="btn btn--prj-min-x w-100@until-medium" @click="select( auflage )">{{'btnChoose'|translate}}</a></div>
                        </div>
                    </template>
                </div>
                <div class="text-xsmall mt-prj2">{{'lblPreisMitKonf'|translate}}</div>
            </div>
        </FlyerlineModal>
    </div>
  </div>
</template>

<script>
import FlyerlineModal from "fragments/FlyerlineModal.vue";

import Tooltip from "components/Tooltip";
import {AUSPRAEGUNGSTATUS} from "../models/enums";

export const OPTION_ID_FARBIGKEIT = "farbigkeit"
export const OPTION_ID_AUFLAGE = "auflagezahl"

    export default {
        name: 'OptionAuflage',
        components: {Tooltip, FlyerlineModal},
        props: ['option'],
        inject: ['optionsService', 'configuratorService', 'globalConfig'],
        data() {
            return {
                auflagenWithPrice: JSON.parse(JSON.stringify(this.option.auspraegungen)),
                tooltip: this.option.tooltip
            }
        },

        computed: {
            editable() {
              return this.option.customValues.minAuflageIndividuell > 0
                  && this.option.customValues.maxAuflageIndividuell > 0
                  && this.option.customValues.schrittgroesseAuflageIndividuell > 0
            },
          individualAuflage() {
              const numAuflagen = this.option.dynamicValues.auflage;
              this.configuratorService.numAuflagen = numAuflagen;
              this.option.dynamicValues.numAuflagen = numAuflagen;
              return this.option.dynamicValues.auflage;
          },
          configInvalid() {
              return !this.configuratorService.isConfigurationComplete()
          },
          message() {
              if( this.option.currentInfo.msgType ) {
                return this.option.currentInfo.text
              } else {
                return "";
              }
          },
          onlyMissingAuflage() {
              return this.configuratorService.observableData.data.configgroups
              .flatMap(group => group.konfigurationsmoeglichkeiten)
              .filter(km => !km.auspraegungen.find(a => a.status === AUSPRAEGUNGSTATUS.SELECTED))
              .every(km => km === this.option);
          },
          canShowPrices() {
              return !this.configInvalid || this.onlyMissingAuflage;
          }
        },

        methods: {
            showModal() {
                this.$modal.show('auflagen')

                if ( this.canShowPrices ) {

                  let data = JSON.parse(JSON.stringify(this.configuratorService.lightweightConf() ) ); // deepcopy
                  data.dynamicValues[this.option.id].auflage = undefined; // reset dynamic auflage, otherwise it will mess with setting different auflage

                  console.log(this.globalConfig)
                  let chunksize = this.globalConfig.auflageModalChunkSize;
                  let chunk = 0;
                  let maxChunk = chunksize === -1 ? 1 : Math.ceil(this.auflagenWithPrice.length / chunksize);

                  while (chunk < maxChunk) {
                    fetch(`/api/prj/products/${this.configuratorService.productId}/prices/${this.option.id}.${languagepath}.json?chunk=${chunk}&chunksize=${chunksize}`, {
                      method: 'POST',
                      body: JSON.stringify(data)
                    }).then( response => response.json() )
                        .then( (response) => {
                          for ( const auflage of this.auflagenWithPrice ) {
                            if( response[auflage.id] ) {
                              this.$set(auflage, 'priceExcl', response[auflage.id]?.exclVat);
                              this.$set(auflage, 'priceIncl', response[auflage.id]?.inclVat);
                              this.$set(auflage, 'normalPriceIncl', response[auflage.id]?.normalPriceInclVat);
                              this.$set(auflage, 'normalPriceExcl', response[auflage.id]?.normalPriceExclVat);
                            }
                          }
                        }).catch( xhr => {
                      console.log("ERROR: Failed to load product conf price!");
                    });
                    chunk++;
                  }
                }
            },
            auflageChange( auflage ) {
              console.log("auflage", auflage)
              this.option.dynamicValues.auflage = undefined;
              this.configuratorService.setSelectedAuspraegung(this.option, auflage.id)
            },
            select(auflage) {
                this.auflageChange( auflage )
                this.$modal.hide('auflagen')
            },
            checkAndUpdateValue( event ) {
              let auflagezahl = event.target.value
              this.option.dynamicValues.auflage = parseInt(auflagezahl);
              this.configuratorService.setSelectedAuspraegung( this.option, 0 ) // deselect
            },
            hideInfoAfterTimeout(){
              if( this.option.currentInfo.msgType === "INFO") {
                let self = this;
                let afterTimeout = function(){
                  self.option.currentInfo.msgType = undefined;
                }
                setTimeout( afterTimeout, 2000);
              }
            }
        },
        watch: {
            option(){
              this.auflagenWithPrice = JSON.parse(JSON.stringify(this.option.auspraegungen));
            },
            message() {
              this.hideInfoAfterTimeout()
            }
        }
    }
</script>
